import styled from "styled-components";
import Link from "next/link";
import {breakpoints} from "@/styles/sizes";
import {getColor} from "@/styles/ThemeConfig";
import Image from "next/image";
import ForceSSRLink from "@/components/other/ForceSSRLink";

import BreadcrumbSeparatorIcon from '/public/images/br_path.svg';

const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  position: relative;
  flex-wrap: wrap;
  row-gap: 10px;

  @media only screen and (${breakpoints.mobile}) {
    div:nth-child(1) {
      display: flex;
      align-items: center;
    }
`;

export const BreadcrumbsLinks = styled.div`
  display: flex;
  align-items: center;
  

  @media only screen and (${breakpoints.mobile}) {
    align-items: baseline;
  }
`;

const Links = styled.div`
  a {
    color: ${getColor('green')};
    font: 16px / 19px "Josefin Sans";
    text-decoration: none;
    white-space: nowrap;
  }
`;

const NoLinkItem = styled.div`
  color: ${getColor('green')};
  font: 16px / 19px "Josefin Sans";
  text-decoration: none;

  &:last-child {
    color: ${getColor('lightGreen')};
  }

  &:hover {
    text-decoration: underline;

    &:last-child {
      text-decoration: none;
    }
  }
`;

export default function Breadcrumbs({ items }) {
  return (
    <BreadcrumbsWrapper>
      {items &&
        items.map((item, index) => {
          if(!item){
        return;
      }
        return <BreadcrumbsLinks key={index}>
        {item?.link ? (
            //   <Links href={item.link}>{item.title}</Links>
            <Links>
              {" "}
              <ForceSSRLink href={item.link}>{item.title}</ForceSSRLink>
            </Links>
        ) : (
            <NoLinkItem>{item.title}</NoLinkItem>
        )}
        {index < items.length - 1 && <Image src={BreadcrumbSeparatorIcon} alt={'~'} style={{marginLeft:'10px', marginRight:'10px'}}/>}
      </BreadcrumbsLinks>

})}
    </BreadcrumbsWrapper>
  );
}
